export const USER_AGREEMENT_LINK = 'https://yandex.ru/legal/ritm_termsofuse/';
